import {Dialog, FormSubmitHandler} from 'platform/components';

import {FieldErrors} from 'react-hook-form';

import {noop, suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {useCreatePageContext} from '../../Create/components/CreatePageContext';
import {VehicleFields} from '../../Create/components/VehicleFields';
import {VehicleFormType} from '../../Create/types/VehicleFormType';

interface EditSpecificationModalProps extends TestIdProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: FormSubmitHandler<VehicleFormType>;
  onInvalidSubmit?: (errors: FieldErrors<VehicleFormType>) => void;
}

export function EditSpecificationModal(props: EditSpecificationModalProps) {
  const {formApi} = useCreatePageContext();
  const handleSave = () => {
    formApi.handleSubmit(props.onSubmit ?? noop, props.onInvalidSubmit ?? noop)();
  };
  return (
    <Dialog
      title={i18n.t('page.import.actions.editSpecification')}
      isOpen={props.isOpen}
      onClose={props.onClose}
      buttons={[
        {
          title: i18n.t('general.actions.cancel'),
          variant: 'secondary',
          onClick: props.onClose,
          'data-testid': suffixTestId('cancelButton', props),
        },
        {
          title: i18n.t('general.actions.save'),
          onClick: handleSave,
          'data-testid': suffixTestId('saveButton', props),
        },
      ]}
      data-testid={suffixTestId('modal', props)}
    >
      <VehicleFields data-testid={suffixTestId('vehicleFields', props)} />
    </Dialog>
  );
}
